import { useLocale } from "../i18n/useLocale.js";

export function PlanCard({ projectName, onProjectNameChange, onReset }) {
  const { display } = useLocale();

  return (
    <section className="rail-card plan-card" aria-labelledby="plan-card-title">
      <h2 id="plan-card-title" className="sr-only">{display.t("web.sections.project")}</h2>
      <label className="plan-name-field">
        <span>{display.t("web.plan.nameLabel")}</span>
        <input
          value={projectName}
          onChange={(event) => onProjectNameChange(event.target.value)}
        />
      </label>
      <button type="button" className="secondary-button plan-reset-button" onClick={onReset}>
        {display.t("web.actions.resetPlan")}
      </button>
    </section>
  );
}
